<template>
  <div class="divider" :style="{ width: this.width ? this.width + 'px' : '100%' }"></div>
</template>

<style scoped>
.divider {
  height: 2px;
  background-color: #3d3d42;
}
</style>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    }
  },
  data: () => ({}),
  created() {},
  computed: {},

  methods: {}
}
</script>



// WEBPACK FOOTER //
// index.vue?cc0f523a